// extracted by mini-css-extract-plugin
export var wrapper = "SubTechMenuDesktop-module--wrapper--c8ae3";